const  initTaxpayerDetailByTin = (old=false, action) => {
    let { type, payload} = action
    switch (type) {
        case "initTaxpayerDetailByTin":
            return payload
        default:
            return old;
    }
}
export default initTaxpayerDetailByTin